import { render, staticRenderFns } from "./ImportIndex.vue?vue&type=template&id=528accd8&scoped=true"
import script from "./ImportIndex.vue?vue&type=script&lang=js"
export * from "./ImportIndex.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/flexben.css?vue&type=style&index=0&id=528accd8&prod&scoped=true&lang=css&external"
import style1 from "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=528accd8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528accd8",
  null
  
)

export default component.exports